export default class UserCreditCardController {
  constructor(resource) {
    this._resource = resource
  }

  async getByIdUser() {
    try {
      let response = await this._resource(`creditCard`).get()
      return response.body
    } catch (error) {
      return result = {
        ok: false,
        message: 'error'
      }
    }
  }

  async getByIdUserParam(userId) {
    return await this
      ._resource(`creditCard/user/${userId}`)
      .get()
      .then(res => res.body)
      .catch(e => { throw e })
  }

  async create(card) {
    try {
     let response = await this._resource(`creditCard`).save(card)
      return {
        ok: true,
        message: response.body
      }
    } catch (error) {
      console.log(error)
      return {
        ok: false,
        message: error.body.erro
      }
    }
  }

  async updateCVV(cvv, card_id) {
    try {
      let response = await this._resource(`creditCard/cvv/${card_id}`).update({ cvv });
      return {
        ok: true,
        message: response.body
      }
    } catch (error) {
      console.log(error);
      return {
        ok: false,
        message: error.body.erro
      }
    }
  }

  async delete(id_card) {
    try {
      let response = await this._resource(`creditCard/${id_card}`).delete()
      return response.body
    } catch (error) {
      return result = {
        ok: false,
        message: 'error'
      }
    }
  }
}
